export const API_URL = "https://api.themoviedb.org/3";

export const API_KEY_3 = "32044039455e2188ce91364820cf17a3";

export const API_KEY_4 =
  "eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIzMjA0NDAzOTQ1NWUyMTg4Y2U5MTM2NDgyMGNmMTdhMyIsInN1YiI6IjVjNTU5NjNiMGUwYTI2MDUwNmM2NjNjNyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.n82zSQteMJ3rKEVFR6nlY9hQwzthOIf74fZZ4LSn-1g";
//export const PAGE = "https://api.themoviedb.org/3/discover/movie?page=2";